interface LoginProps {
  onLogin: () => void
}

export function Login({ onLogin }: LoginProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8 p-8">
        <div>
          <h1 className="text-center text-4xl font-bold text-gray-900">CloudFileShare</h1>
          <p className="mt-2 text-center text-gray-600">
            Secure file storage powered by AWS
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl font-semibold text-center text-gray-900 mb-6">
            Welcome
          </h2>
          <p className="text-center text-gray-600 mb-8">
            Sign in to access your files
          </p>
          <button
            onClick={onLogin}
            className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            Sign In
          </button>
        </div>

        <p className="text-center text-sm text-gray-500">
          Contact your administrator if you need an account
        </p>
      </div>
    </div>
  )
}
